import { createFileRoute } from "@tanstack/react-router";

import { UsageSettingsPanel } from "../components/settings/UsageSettingsPanel";

function SettingsUsageRouteView() {
  return <UsageSettingsPanel />;
}

export const Route = createFileRoute("/_app/settings/usage")({
  component: SettingsUsageRouteView,
});
